import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, Platform, ModalController, LoadingController, Loading, Content, Slides } from 'ionic-angular';
import { WheelSelector } from '@ionic-native/wheel-selector';

import { EmployeeDetailsPage } from '../employees/employee-details/employee-details';
import { IEmployee, ITimeRegistration, TimeRegistration, IProject, Project, Employee } from '../../model/top.model';

import { EmployeeData } from '../../providers/employee-data';
import { TimeRegistrationData } from '../../providers/time-registration-data';

import { TimeRegistrationStatus, TimeRegistrationType, Jobrole } from '../../enums/enums';

import { EditTextModal } from '../../modals/edit-text/edit-text';

@Component({
  selector: 'page-time-registrations',
  templateUrl: 'time-registrations.html'
})
export class TimeRegistrationsPage {
  @ViewChild(Content) content: Content;
  @ViewChild(Slides) slides: Slides;

  isMobile: boolean;
  private employees: Array<IEmployee>;
  private filteredEmployees: Array<IEmployee>;
  loadedEmployees: Array<IEmployee>;
  private weekNumber: string;
  private maxWeeks: number;
  private week: string;
  private year: string;
  private monday: Date;
  private tuesday: Date;
  private wednesday: Date;
  private thursday: Date;
  private friday: Date;
  private saturday: Date;
  private sunday: Date;
  private weeks: Array<number>;
  private weekInMilliseconds: number = 604800000;
  TimeRegistrationStatus = TimeRegistrationStatus;
  private months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  private month: string;
  private Jobrole = Jobrole;
  filterName: string;
  private statusFilter: number;
  private loadingView: Loading;
  private loadingLength: number;
  private slidesIndex: number;
  private settingStatus: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private employeeData: EmployeeData,
    // private projectData: ProjectData,
    private timeRegistrationData: TimeRegistrationData,
    // private translate: TranslateService,
    private platform: Platform,
    private selector: WheelSelector,
    private loading: LoadingController,
  ) {
    this.isMobile = platform.is('cordova');
    this.employees = [];
    this.loadedEmployees = [];
    this.loadingLength = 10;
    this.filterName = "";
    this.statusFilter = TimeRegistrationStatus.all;
    let monday = this.timeRegistrationData.mondayOfWeek(new Date());
    this.monday = monday;
    this.tuesday = monday;
    this.wednesday = monday;
    this.thursday = monday;
    this.friday = monday;
    this.saturday = monday;
    this.sunday = monday;
    this.loadingView = this.loading.create({
      content: 'Uren laden...'
    });
    this.loadingView.present().then(() => {
      this.initWeek(monday);
    });
  }

  getHeaderStyle(project: IProject) {
    return 'time-registrations-header-' + project.timeRegistrationsStatus;
  }

  getPlatformStyle() {
    if (this.platform.is('ios')) {
      return 'platform-ios';
    }
    return 'platform-android';
  }

  initWeek(date) {
    this.month = this.months[date.getMonth()];
    this.monday = date;
    this.monday.setDate(this.monday.getDate() - this.monday.getDay() + 1);
    this.monday.setHours(0, 0, 0, 0);
    this.tuesday = new Date(this.monday);
    this.tuesday.setDate(this.monday.getDate() + 1);
    this.tuesday.setHours(0, 0, 0, 0);
    this.wednesday = new Date(this.monday);
    this.wednesday.setDate(this.monday.getDate() + 2);
    this.wednesday.setHours(0, 0, 0, 0);
    this.thursday = new Date(this.monday);
    this.thursday.setDate(this.monday.getDate() + 3);
    this.thursday.setHours(0, 0, 0, 0);
    this.friday = new Date(this.monday);
    this.friday.setDate(this.monday.getDate() + 4);
    this.friday.setHours(0, 0, 0, 0);
    this.saturday = new Date(this.monday);
    this.saturday.setDate(this.monday.getDate() + 5);
    this.saturday.setHours(0, 0, 0, 0);
    this.sunday = new Date(this.monday);
    this.sunday.setDate(this.monday.getDate() + 6);
    this.sunday.setHours(0, 0, 0, 0);

    let weekArrayObject = this.timeRegistrationData.getWeekNumber(this.monday);
    this.year = weekArrayObject[0].toString();
    this.week = weekArrayObject[1].toString();
    this.weekNumber = this.week.length == 1 ? this.year + "-01-01T00:0" + this.week : this.year + "-01-01T00:" + this.week;

    this.weeks = [];
    this.maxWeeks = this.timeRegistrationData.getWeeksInYear(this.monday.getFullYear());
    for (var index = 1; index <= this.maxWeeks; index++) {
      this.weeks.push(index);
    }
    this.setEmployeesTimeRegistrations(true);
  }

  setEmployeesTimeRegistrations(scroll: boolean) {
    this.employeeData.getEmployees(false, this.year, this.week).then((result: Array<IEmployee>) => {
      this.employees = (this.employeeData.jobRoles.indexOf(Jobrole.loonadministratie) > -1 || this.employeeData.jobRoles.indexOf(Jobrole.fiatteur) > -1 || this.employeeData.jobRoles.indexOf(Jobrole.directie) > -1 || this.employeeData.jobRoles.indexOf(Jobrole.administrator) > -1) ? result : result.filter(employee => this.employeeData.loggedInEmployeeId === employee.approver_id);
      // calculations moved to backend
      // this.employees.sort(function (a, b) {
      //   if (a.last_name < b.last_name) return -1;
      //   if (a.last_name > b.last_name) return 1;
      //   if (a.first_name < b.first_name) return -1;
      //   if (a.first_name > b.first_name) return 1;
      //   return 0;
      // });
      this.employees.forEach((employee) => {
        employee.totalHours = 0;
        employee.totalMonday = 0;
        employee.totalTuesday = 0;
        employee.totalWednesday = 0;
        employee.totalThursday = 0;
        employee.totalFriday = 0;
        employee.totalSaturday = 0;
        employee.timeRegistrationsStatus = 0;
        employee.projects.forEach((project) => {
          employee.projectsFiltered = [];
          project.timeRegistrationsFiltered = project.timeRegistrations;
          this.setEmployeeProjectTimeRegistrations(project, employee);
        });
        employee.projects.sort(function (a, b) {
          if (a.hall < b.hall) return -1;
          if (a.hall > b.hall) return 1;
          return 0;
        });
        employee.projectsFiltered = employee.projects;
        // set leave timeRegistrations
        const leave = employee.timeRegistrations.filter((timeRegistration) => timeRegistration.type != TimeRegistrationType.OpbouwTijdVoorTijd && (timeRegistration.type <= 100 || timeRegistration.type >= 300) && timeRegistration.project_id.indexOf("\u0000") > -1);
        if (leave.length > 0) {
          let leaveProject = new Project(" Afwezigheid", "");
          leaveProject.timeRegistrations = leaveProject.timeRegistrationsFiltered = leave;
          this.setEmployeeProjectTimeRegistrations(leaveProject, employee);
        }

        // set office timeRegistrations
        const office = employee.timeRegistrations.filter((timeRegistration) => timeRegistration.type != TimeRegistrationType.OpbouwTijdVoorTijd && timeRegistration.type > 100 && timeRegistration.type <= 200 && timeRegistration.project_id.indexOf("\u0000") > -1);
        if (office.length > 0) {
          let officeProject = new Project(" Kantoor Algemeen", "");
          officeProject.timeRegistrations = officeProject.timeRegistrationsFiltered = office;
          this.setEmployeeProjectTimeRegistrations(officeProject, employee);
        }

        // set service/transport timeRegistrations
        const service_transport = employee.timeRegistrations.filter((timeRegistration) => timeRegistration.type != TimeRegistrationType.OpbouwTijdVoorTijd && timeRegistration.type > 200 && timeRegistration.type < 300 && timeRegistration.project_id.indexOf("\u0000") > -1);
        if (service_transport.length > 0) {
          let serviceProject = new Project(" Service/Transport Algemeen", "");
          serviceProject.timeRegistrations = serviceProject.timeRegistrationsFiltered = service_transport;
          this.setEmployeeProjectTimeRegistrations(serviceProject, employee);
        }
        // set time for time timeRegistrations
        const tft = employee.timeRegistrations.filter((timeRegistration) => timeRegistration.type == TimeRegistrationType.OpbouwTijdVoorTijd);
        if (tft.length > 0) {
          let tftProject = new Project(" Tijd voor tijd", "");
          tftProject.timeRegistrations = tftProject.timeRegistrationsFiltered = tft;
          this.setEmployeeProjectTimeRegistrations(tftProject, employee);
        }
      });
      this.filterTimeRegistrations();
      this.loadingView.dismiss();
    });
  }

  setEmployeeProjectTimeRegistrations(project: IProject, employee: IEmployee) {
    project.timeRegistrationsStatus = project.timeRegistrations[0].status;
    let newTimeRegistrationStatus = this.checkProjectStatus(project, employee.timeRegistrationsStatus)
    if (newTimeRegistrationStatus) {
      employee.timeRegistrationsStatus = newTimeRegistrationStatus;
    }
    employee.totalHours += project.totalHours = this.timeRegistrationData.getHoursForProject(project);
    employee.totalMonday += project.totalMonday = this.timeRegistrationData.getHoursForProjectDay(project, 'mondayHHmm');
    employee.totalTuesday += project.totalTuesday = this.timeRegistrationData.getHoursForProjectDay(project, 'tuesdayHHmm');
    employee.totalWednesday += project.totalWednesday = this.timeRegistrationData.getHoursForProjectDay(project, 'wednesdayHHmm');
    employee.totalThursday += project.totalThursday = this.timeRegistrationData.getHoursForProjectDay(project, 'thursdayHHmm');
    employee.totalFriday += project.totalFriday = this.timeRegistrationData.getHoursForProjectDay(project, 'fridayHHmm');
    employee.totalSaturday += project.totalSaturday = this.timeRegistrationData.getHoursForProjectDay(project, 'saturdayHHmm');
    employee.projectsFiltered.push(project);
  }

  checkProjectStatus(project: IProject, timeRegistrationsStatus): TimeRegistrationStatus {
    switch (project.timeRegistrationsStatus) {
      case TimeRegistrationStatus.open:
        return TimeRegistrationStatus.open;
      case TimeRegistrationStatus.rejected:
        return TimeRegistrationStatus.open;
      case TimeRegistrationStatus.submitted:
        if (timeRegistrationsStatus != TimeRegistrationStatus.open) {
          return TimeRegistrationStatus.submitted;
        }
        break;
      case TimeRegistrationStatus.checked:
        if (timeRegistrationsStatus != TimeRegistrationStatus.open && timeRegistrationsStatus != TimeRegistrationStatus.submitted) {
          return TimeRegistrationStatus.checked;
        }
        break;
      case TimeRegistrationStatus.approved:
        if (timeRegistrationsStatus != TimeRegistrationStatus.open && timeRegistrationsStatus != TimeRegistrationStatus.checked) {
          return TimeRegistrationStatus.approved;
        }
        break;
      case TimeRegistrationStatus.done:
        if (timeRegistrationsStatus != TimeRegistrationStatus.open && timeRegistrationsStatus != TimeRegistrationStatus.submitted) {
          return TimeRegistrationStatus.done;
        }
        break;
    }
    return null;
  }

  filterTimeRegistrations() {
    if (this.employees) {
      this.filteredEmployees = this.employees.filter((employee) => {
        if (this.filterName && !(employee.first_name.toLowerCase().indexOf(this.filterName.toLowerCase()) > -1 || employee.last_name.toLowerCase().indexOf(this.filterName.toLowerCase()) > -1)) {
          return false;
        }
        if (this.statusFilter == TimeRegistrationStatus.all) {
          return true;
        }
        if (this.statusFilter == TimeRegistrationStatus.mine && this.employeeData.loggedInEmployeeId == employee.approver_id) {
          return true;
        }
        let count = 0;
        for (let index = 0; index < employee.projectsFiltered.length; index++) {
          const project = employee.projectsFiltered[index];
          for (let index2 = 0; index2 < project.timeRegistrations.length; index2++) {
            count++;
            const timeRegistration = project.timeRegistrations[index2];
            if (timeRegistration.status == this.statusFilter) {
              return true;
            }
          }
        }
        if (count == 0 && this.statusFilter == TimeRegistrationStatus.empty) {
          return true;
        }
        return false;
      });
    }
  }

  wheelSelectYear() {
    let data = {
      years: []
    }
    for (let index = 2018; index <= 2100; index++) {
      data.years.push({ description: index.toString() });
    }
    this.selector.show({
      title: "Selecteer jaar",
      items: [
        data.years
      ],
      theme: "dark",
      defaultItems: [{ index: 0, value: this.year }],
      positiveButtonText: "Ok",
      negativeButtonText: "Annuleren"
    }).then(
      result => {
        this.year = result[0].description;
        this.updateFromDateTime();
      },
      err => console.log('wheelSelectYear Error: ' + err)
    );
  }

  wheelSelectWeek() {
    let data = {
      weeks: []
    }
    for (let index = 1; index <= this.maxWeeks; index++) {
      data.weeks.push({ description: index.toString() });
    }
    this.selector.show({
      title: "Selecteer week",
      items: [
        data.weeks
      ],
      theme: "dark",
      defaultItems: [{ index: 0, value: this.week }],
      positiveButtonText: "Ok",
      negativeButtonText: "Annuleren"
    }).then(
      result => {
        this.week = result[0].description;
        this.weekNumber = this.week.length == 1 ? this.year + "-01-01T00:0" + this.week : this.year + "-01-01T00:" + this.week;
        this.updateFromDateTime();
      },
      err => console.log('wheelSelectWeek Error: ' + err)
    );
  }

  checkEnableTimeregistrationInput(timeRegistration: ITimeRegistration) {
    //for now always disable;
    return false;
    // return !(timeRegistration.status === TimeRegistrationStatus.open ||
    //   timeRegistration.status === TimeRegistrationStatus.rejected ||
    //   (timeRegistration.status === TimeRegistrationStatus.submitted && this.employeeData.jobRoles.indexOf(Jobrole.fiatteur) > -1) ||
    //   (timeRegistration.status === TimeRegistrationStatus.checked && this.employeeData.jobRoles.indexOf(Jobrole.fiatteur) == -1) ||
    //   timeRegistration.status === TimeRegistrationStatus.approved ||
    //   timeRegistration.status === TimeRegistrationStatus.done);
  }

  wheelSelectTimeRegistration(project, timeRegistration, HHmm) {
    if (!this.checkEnableTimeregistrationInput(timeRegistration)) {
      return;
    }
    let data = {
      uren: [],
      minuten: [{ description: "00" }, { description: "30" }]
    }
    for (let index = 0; index < 24; index++) {
      let mm = index.toString();
      if (mm.length == 1) {
        mm = "0" + mm;
      }
      data.uren.push({ description: mm })
    }

    this.selector.show({
      title: "Uren en halve uren",
      items: [
        data.uren,
        data.minuten
      ],
      defaultItems: [{ index: 0, value: timeRegistration[HHmm].substr(0, 2) }, { index: 1, value: timeRegistration[HHmm].substr(3, 2) }],
      theme: "dark",
      positiveButtonText: "Ok",
      negativeButtonText: "Annuleren"
    }).then(
      result => {
        timeRegistration[HHmm] = result[0].description + ':' + result[1].description;
        this.updateProjectTimeRegistrations(project, this.loadedEmployees[this.slidesIndex]);
      },
      err => console.log('wheelSelectTimeRegistration Error: ' + err)
    );

  }

  nextWeek() {
    this.monday = new Date(this.monday.getTime() + this.weekInMilliseconds);
    this.loadingView = this.loading.create({
      content: 'Uren laden...'
    });
    this.loadingView.present().then(() => {
      this.initWeek(this.monday);
    });
  }

  previousWeek() {
    this.monday = new Date(this.monday.getTime() - this.weekInMilliseconds);
    this.loadingView = this.loading.create({
      content: 'Uren laden...'
    });
    this.loadingView.present().then(() => {
      this.initWeek(this.monday);
    });
  }

  updateFromDateTime() {
    this.monday = this.timeRegistrationData.getMondayOfWeekInYear(this.weekNumber.substr(14, 2), this.year);
    this.loadingView = this.loading.create({
      content: 'Uren laden...'
    });
    this.loadingView.present().then(() => {
      this.initWeek(this.monday);
    });
  }

  editRemark(timeRegistration) {
    let inputModal = this.modalCtrl.create(EditTextModal, { editText: timeRegistration.remarks, title: 'Opmerking(en) afgekeurd' });
    inputModal.present();
    inputModal.onDidDismiss(newTextObject => {
      if (newTextObject) {
        timeRegistration.remarks = newTextObject.text;
        this.timeRegistrationData.setTimeRegistrationStatus(timeRegistration);
      }
    });
  }

  editRemarkPrivate(timeRegistration) {
    let inputModal = this.modalCtrl.create(EditTextModal, { editText: timeRegistration.remarks_private, title: 'Opmerking(en) lonen' });
    inputModal.present();
    inputModal.onDidDismiss(newTextObject => {
      if (newTextObject) {
        timeRegistration.remarks_private = newTextObject.text;
        this.timeRegistrationData.setTimeRegistrationStatus(timeRegistration);
      }
    });
  }

  editRemarkCheck(timeRegistration) {
    let inputModal = this.modalCtrl.create(EditTextModal, { editText: timeRegistration.remarks_check, title: 'Opmerking(en) niet goed' });
    inputModal.present();
    inputModal.onDidDismiss(newTextObject => {
      if (newTextObject) {
        timeRegistration.remarks_check = newTextObject.text;
        this.timeRegistrationData.setTimeRegistrationStatus(timeRegistration);
      }
    });
  }

  showRemarkCheck(timeRegistration: ITimeRegistration) {
    let alert = this.alertCtrl.create({
      title: 'Opmerking(en) niet goed',
      subTitle: timeRegistration.remarks_check,
      buttons: ['Ok']
    });
    alert.present();
  }

  employeeTapped(event, employee) {
    this.navCtrl.push(EmployeeDetailsPage, {
      employee: employee
    });
  }

  setStatusEmployeeOk(employee: IEmployee) {
    this.settingStatus = true;
    let projectsArray = [];
    employee.projects.forEach(project => {
      // project.totalHours = this.timeRegistrationData.getHoursForProject(project);
      switch (project.timeRegistrationsStatus) {
        // case TimeRegistrationStatus.open:
        //   project.timeRegistrationsStatus = TimeRegistrationStatus.submitted;
        //   break;
        case TimeRegistrationStatus.submitted:
          if (this.employeeData.jobRoles.indexOf(Jobrole.urencontrole) > -1 || this.employeeData.jobRoles.indexOf(Jobrole.loonadministratie) > -1) {
            project.timeRegistrationsStatus = TimeRegistrationStatus.checked;
          }
          break;
        case TimeRegistrationStatus.checked:
          if (this.employeeData.jobRoles.indexOf(Jobrole.fiatteur) > -1 || this.employeeData.jobRoles.indexOf(Jobrole.directie) > -1 || this.employeeData.jobRoles.indexOf(Jobrole.loonadministratie) > -1) {
            project.timeRegistrationsStatus = TimeRegistrationStatus.approved;
          }
          break;
        // case TimeRegistrationStatus.approved:
        //   project.timeRegistrationsStatus = TimeRegistrationStatus.done;
        //   break;
        case TimeRegistrationStatus.rejected:
          project.timeRegistrationsStatus = TimeRegistrationStatus.submitted;
          break;
      }
      this.checkEmployeeStatus(employee);
      project.timeRegistrations.forEach((timeRegistration) => {
        projectsArray.push(this.updateTimeRegistration(project, timeRegistration));
      });
    });
    Promise.all(projectsArray).then(() => {
      this.settingStatus = false;
      this.filteredEmployees[this.slidesIndex] = employee;
      // this.setEmployeesTimeRegistrations(false);
    });

    // employee.projects.forEach(project => {
    //   this.setStatusOk(project);
    // });
  }

  checkEmployeeStatus(employee: IEmployee) {
    employee.timeRegistrationsStatus = null;
    employee.projectsFiltered.forEach((project) => {
      let newTimeRegistrationStatus = this.checkProjectStatus(project, employee.timeRegistrationsStatus);
      console.log(project.timeRegistrationsStatus + ' | ' + employee.timeRegistrationsStatus + ' | ' + newTimeRegistrationStatus);
      if (newTimeRegistrationStatus) {
        employee.timeRegistrationsStatus = newTimeRegistrationStatus;
      }
    });
  }

  setStatusOk(project: IProject, employee: IEmployee) {
    switch (project.timeRegistrationsStatus) {
      // case TimeRegistrationStatus.open:
      //   project.timeRegistrationsStatus = TimeRegistrationStatus.submitted;
      //   break;
      case TimeRegistrationStatus.submitted:
        project.timeRegistrationsStatus = TimeRegistrationStatus.checked;
        break;
      case TimeRegistrationStatus.checked:
        project.timeRegistrationsStatus = TimeRegistrationStatus.approved;
        break;
      // case TimeRegistrationStatus.approved:
      //   project.timeRegistrationsStatus = TimeRegistrationStatus.done;
      //   break;
      case TimeRegistrationStatus.rejected:
        project.timeRegistrationsStatus = TimeRegistrationStatus.submitted;
        break;
    }
    this.updateProjectTimeRegistrations(project, employee);
  }

  updateProjectTimeRegistrations(project: IProject, employee: IEmployee) {
    let projectsArray = [];
    project.timeRegistrations.forEach((timeRegistration) => {
      projectsArray.push(this.updateTimeRegistration(project, timeRegistration));
    });
    Promise.all(projectsArray).then(() => {
      // project.totalHours = this.timeRegistrationData.getHoursForProject(project);
      this.checkEmployeeStatus(employee);
      this.filteredEmployees[this.slidesIndex] = employee;
      // this.setEmployeesTimeRegistrations(false);
    });
  }

  updateTimeRegistration(project: IProject, timeRegistration: TimeRegistration): Promise<any> {
    timeRegistration.status = project.timeRegistrationsStatus;
    return this.timeRegistrationData.setTimeRegistrationStatus(timeRegistration).then(() => {

    }, error => {
      const alert = this.alertCtrl.create({
        message: JSON.stringify(error.error[0]),
        buttons: ['Ok']
      });
      alert.onDidDismiss(()=> {
        this.loadingView = this.loading.create({
          content: 'Uren laden...'
        });
        this.loadingView.present().then(() => {
          this.initWeek(this.monday);
        });
      });
      alert.present();
    });
  }


  sendRejectedNotification(project: IProject, employee_id: string, message: string, title: string) {
    this.employeeData.sendMessageToEmployee(employee_id, message, title);
  }

  setStatusNotOk(project: IProject, employee: IEmployee) {
    switch (project.timeRegistrationsStatus) {
      case TimeRegistrationStatus.submitted:
        project.timeRegistrationsStatus = TimeRegistrationStatus.rejected;
        this.sendRejectedNotification(project, employee.employee_id, `Je uren van ${project.name} zijn niet akkoord. Controleer je uren en dien ze opnieuw in.`, `Je uren van ${project.name} zijn niet akkoord.`);
        break;
      case TimeRegistrationStatus.checked:
        project.timeRegistrationsStatus = TimeRegistrationStatus.submitted;
        this.sendRejectedNotification(project, employee.approver_id, `De uren van ${employee.first_name} ${employee.middle_name ? employee.middle_name + " " : ""}${employee.last_name} op project ${project.name} zijn niet akkoord. Controleer de uren en dien ze opnieuw in.`, `De uren van ${employee.first_name} ${employee.middle_name ? employee.middle_name + " " : ""}${employee.last_name} zijn niet akkoord.`);
        break;
      case TimeRegistrationStatus.approved:
        project.timeRegistrationsStatus = TimeRegistrationStatus.checked;
        break;
      // case TimeRegistrationStatus.done:
      //   project.timeRegistrationsStatus = TimeRegistrationStatus.approved;
      //   break;
    }
    this.updateProjectTimeRegistrations(project, employee);
  }
}



// WEBPACK FOOTER //
// ./src/pages/time-registrations/time-registrations.ts